const fr = {
  'home.WELCOME_TITLE': 'Bonjour partenaire! Comment ça va?',
  'home.WELCOME_MESSAGE': 'Bonjour partenaire! Comment ça va?',
};

export default fr;
